






import { Component, Mixins, Prop, Provide } from 'vue-property-decorator';
import { SeriesOptionsType } from 'highcharts';
import { TAcquisitionMode, TChart } from '@/plugins/podolib/services/helper/mixins/chart';
import MixinChartsEvolution from '@/plugins/podolib/services/helper/mixins/chart/evolution';

@Component
export default class ChartEvolutionStancePhaseToeOff extends Mixins(MixinChartsEvolution) implements TChart {
  // Chart name for exportation
  name = 'ChartEvolutionStancePhaseToeOff';

  // Calculs
  get __toe_off_left() {
    return this.acquisitions.map((value) =>
      this.isWalkAnalysis ? this.getLeft(value).pronation_angle_foot_out.avg : this.getLeft(value).angle_foot_out.avg,
    );
  }
  get __toe_off_range_left() {
    return this.acquisitions.map((value, key) => {
      const proSup = this.isWalkAnalysis
        ? this.getLeft(value).pronation_angle_foot_out
        : this.getLeft(value).angle_foot_out;
      return {
        x: key,
        low: proSup.avg - proSup.std,
        high: proSup.avg + proSup.std,
      };
    });
  }
  get __toe_off_right() {
    return this.acquisitions.map((value) =>
      this.isWalkAnalysis ? this.getRight(value).pronation_angle_foot_out.avg : this.getRight(value).angle_foot_out.avg,
    );
  }
  get __toe_off_right_range() {
    return this.acquisitions.map((value, key) => {
      const proSup = this.isWalkAnalysis
        ? this.getRight(value).pronation_angle_foot_out
        : this.getRight(value).angle_foot_out;
      return {
        x: key,
        low: proSup.avg - proSup.std,
        high: proSup.avg + proSup.std,
      };
    });
  }

  // Series
  get _val(): SeriesOptionsType[] {
    return [
      {
        id: 'toe_off_left',
        name: `${this.$t('commons.standards.toe-off')} (${(this.$t('commons.standards.left') as string).slice(0, 1)})`,
        data: this.__toe_off_left,
        color: this.$vuetify.theme.themes.light.chart1 as string,
        type: this.lineType,
        marker: {
          symbol: this.markerType,
        },
      },
      {
        id: 'toe_off_left_range',
        data: this.__toe_off_range_left,
        color: (this.$vuetify.theme.themes.light.chart1 + '44') as string,
        linkedTo: 'toe_off_left',
        type: this.rangeType,
        marker: {
          enabled: false,
          symbol: this.markerType,
        },
        opacity: this.shapeOpacity,
      },
      {
        id: 'toe_off_right',
        name: `${this.$t('commons.standards.toe-off')} (${(this.$t('commons.standards.right') as string).slice(0, 1)})`,
        data: this.__toe_off_right,
        color: this.$vuetify.theme.themes.light.chart2 as string,
        type: this.lineType,
        marker: {
          symbol: this.markerType,
        },
      },
      {
        id: 'toe_off_right_range',
        data: this.__toe_off_right_range,
        color: (this.$vuetify.theme.themes.light.chart2 + '44') as string,
        linkedTo: 'toe_off_right',
        type: this.rangeType,
        marker: {
          enabled: false,
          symbol: this.markerType,
        },
        opacity: this.shapeOpacity,
      },
    ];
  }

  get series() {
    return [...this._val];
  }

  created() {
    let _this = this;
    this.setOptions({
      chart: {
        type: this.lineType,
        height: 300,
      },
      title: {
        text: this.$tc('commons.standards.toe-off'),
      },
      xAxis: {
        title: {
          text: this.$tc('commons.standards.acquisition', 2),
        },
        allowDecimals: false,
        crosshair: {
          width: 40,
          color: 'rgba(206,214,217,0.2)',
        },
        labels: {
          enabled: false,
        },
      },
      yAxis: {
        title: {
          text: this.$tc('commons.units.degree', 2),
        },
      },
      tooltip: {
        shared: true,
        useHTML: true,
        followPointer: true,
        borderWidth: 2,
        backgroundColor: 'rgba(255,255,255, 0.97)',
        borderColor: '#f5f7fa',
        borderRadius: 10,
        shadow: false,
        formatter() {
          // String buffer
          let s = '<tr><td></br>';
          // Iterate on the points
          for (const p of this.points!) {
            // Determinate if it's a range
            const isRange = /^Series \d+$/.test(p.series.name);
            // Populate string buffer
            if (!isRange) {
              s += `<span style="color: ${p.color}; font-weight: bold">${p.series.name}</span> : `;
              s += `<b>${p.point.y!.toFixed(1)}</b> °`;
            } else {
              s += `<span style="margin-left: 10px; color: grey">(${p.point.low!.toFixed(1)} ⁃ ${p.point.high!.toFixed(
                1,
              )})</span>`;
              // Close the row
              s += '<tr><td>';
            }
          }
          return `<table><thead><tr><th style="font-size: 15px">${_this
            .$moment(_this.acquisitions[this.points![0].point.x].createdAt)
            .format('LL')} : ${_this
            .$moment(_this.acquisitions[this.points![0].point.x].createdAt)
            .format('HH:mm')}</th></tr></thead><tbody>${s}</tbody></table>`;
        },
      },
      exporting: {
        buttons: {
          contextButton: {
            theme: {
              fill: 'transparent',
            },
            symbolStrokeWidth: 1.5,
            symbolStroke: '#afc1db',
          },
        },
      },
      series: [],
    });
    this.setSeries(this.series);
  }
}
